import React from "react";

const HtmlIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="21"
      viewBox="0 0 20 23"
    >
      <g
        id="Group_31172"
        dataName="Group 31172"
        transform="translate(-1310.656 -414)"
      >
        <text
          id="_"
          dataName="&lt;/&gt;"
          transform="translate(1314.156 428)"
          fill="#fff"
          fontSize="9"
          fontFamily="MyriadPro-BoldCond, Myriad Pro"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            &lt;/&gt;
          </tspan>
        </text>
        <g
          id="Rectangle_16349"
          dataName="Rectangle 16349"
          transform="translate(1310.656 414)"
          fill="none"
          stroke="#fff"
          strokeWidth="1.3"
        >
          <rect width="20" height="23" stroke="none" />
          <rect x="0.65" y="0.65" width="18.7" height="21.7" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default HtmlIcon;



// WEBPACK FOOTER //
// ./src/assets/HtmlIcon.jsx